import { Injector } from "@angular/core";
import { GridActionHandlerBase } from "../../../../../../components/common/grid-base/actions/grid-action-handler-base";
import { WorkspaceBase } from "../../../../../../components/common/workspace-base/workspace-base";
import { TranslateService } from "@ngx-translate/core";

/**
 * Publish report
 */
export class PrintReportGridActionHandler extends GridActionHandlerBase {
  /**
   * Check print in progress?
   */
  private CHECK_PRINT_IN_PROGRESS = true;

  /**
    * Constructor
    * @param injector Ihe Angular injector
    * @param workspace The workspace in which the action should be performed
    * @param translate TranslateService
    */
  constructor(injector: Injector, workspace: WorkspaceBase, private translate: TranslateService) {
    super(injector, workspace, 'buttonPublish');
  }

  /**
  * Handles an event
  * @param _event The event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(): void {
    const checkedReports = this.workspace.grid.getFlattenGridDataResultData().filter(item => item.checkbox);

    //check if no conversion rates (just for active reports as these are only ones to be printed)
    const reportWithoutCurrencyConversion = checkedReports
      .filter(item => item.RecordStatusId !== 2 && !item.HasCurrencyConversionRate)
      .map(item => {
        return {
          LocalCurrencyDescription: item.LocalCurrencyDescription,
          ReportCurrencyDescription: item.ReportCurrencyDescription,
          ValuationProjectIdDescription: item.ValuationProjectIdDescription,
        };
      });

    if (reportWithoutCurrencyConversion.length > 0) {
      this.eventBus.broadcastEvent("openConfirmDialog", {
        customMessage: () => {
          let message = `Please enter an exchange rate for the currency pair(s): <br>`;
          reportWithoutCurrencyConversion.forEach(report => message += `${report.LocalCurrencyDescription} - ${report.ReportCurrencyDescription} for ${report.ValuationProjectIdDescription} Valuation Event<br>`);
          return message;
        },
        success: () => {
          return;
        }
      }, 'missingConversionRate');
    } else {
      const reportsToBePrinted = checkedReports.filter(item => item.RecordStatusId !== 2).map(item => item);
      const inactiveReports = checkedReports.filter(item => item.RecordStatusId === 2).map(item => item.Oid);

      if (inactiveReports.length > 0) {
        if (reportsToBePrinted.length === 0) {//0 here, because inactive wasn't added to array (but was choosen)
          alert(this.translate.instant('errorMessage.inactiveReportForbiddenAction'));
          return;
        } else {
          alert(this.translate.instant('errorMessage.inactiveReportsExcludedFromAction'));
        }
      }

      if (reportsToBePrinted.length === 0) {
        this.eventBus.broadcastEvent("openConfirmDialog", {
          success: () => {
            //Nothing
          }
        }, 'errorMessageChooseReport');
      }
      else {
        this.handlePublishReports(reportsToBePrinted);
      }
    }
  }

  /**
  * Handles publishing of valid reports (after all checks are done)
  * @param reports Array of reports
  */
  private handlePublishReports(reports: any[]) {
    //Task 19797: On print request check if one for report is already running
    //but we have to check if some of reports are already in print (waiting for print or printing at the moment)

    const reportIds = reports.map(r => r.Oid);
    this.reportsAlreadyInPrintProcess(reportIds).then((inProgressReportIds: number[]) => {
      if (inProgressReportIds.length === 0) {
        this.eventBus.broadcastEvent('selectPublishReportMethod', reports);
      } else {
        this.displayInProgressDialog(inProgressReportIds);
      }
    });
  }

  /**
  * Checks if some reports are already in print process
  * @param reportIds Array of report ids
  */
  private reportsAlreadyInPrintProcess(reportIds: number[]): Promise<number[]> {
    return new Promise<number[]>((resolve) => {
      if (this.CHECK_PRINT_IN_PROGRESS) {
        const url = this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `printpublish/report/checkprogress`);
        this.http.post(url, reportIds).subscribe((result: any) => {
          resolve(result.array);
        });
      } else {
        resolve([]);
      }
    });
  }

  /**
   * Displays the pront in progress dialog
   * @param reportIds
   */
  private displayInProgressDialog(reportIds: number[]): void {
    this.eventBus.broadcastEvent("openConfirmDialog", {
      customMessage: () => {
        const reportsCsv = reportIds.join(', ');
        let message = reportIds.length === 1
          ? `Report ${reportsCsv} is`
          : `Reports ${reportsCsv} are`
        message += ` already in print process..<br>`;
        return message;
      },
      success: () => {
        return;
      }
    }, 'printAlreadyInProgress');
  }
}
